const mapStateToProps = state => 
     ({         
         step: state.signUp.step,
    });

export default mapStateToProps;
